import { Services } from '@sigma-frontend-libs/commons'

import characters from '@/components/services/url-shortener/commons/item/characters'
import expireFields from '@/components/services/url-shortener/commons/item/expireFields'
import generationParams from '@/components/services/url-shortener/commons/item/generationParams'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderTitle(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.title ?? this.getTranslate('commons.no.data'),
        label: this.getTranslate(`${serviceNameViaPoint}.labels.title`),
        service: Services['url-shortener-settings/presets'],
        to: {
          name: `${serviceNameViaPoint}.single`,
          params: { id: this.value.id }
        }
      }
    }
  )
}
function renderDomain(h) {
  if (this.viewport.size.width > 600) {
    return h(
      sticker,
      {
        props: this.domainStickerProps
      }
    )
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 1080) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          copy: true
        }
      }
    )
  }
}
function renderCharacters(h) {
  return h(
    characters,
    {
      props: {
        value: this.value.generationParams
      }
    }
  )
}
function renderGenerationParams(h) {
  return h(
    generationParams,
    {
      props: {
        value: this.value.generationParams
      }
    }
  )
}
function renderExpireFields(h) {
  return h(
    expireFields,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderIcons(h) {
  if (this.viewport.size.width > 1600) {
    return h(
      'div',
      {
        class: `${Services['url-shortener']}-item__icons`
      },
      [
        renderCharacters.call(this, h),
        renderGenerationParams.call(this, h),
        renderExpireFields.call(this, h)
      ]
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${serviceNameKebabCase}-item__info`]: true,
        [`${serviceNameKebabCase}-item__info--admin`]: this.canGetUsers
      }
    },
    [
      renderTitle.call(this, h),
      renderDomain.call(this, h),
      renderOwner.call(this, h),
      renderIcons.call(this, h)
    ]
  )
}
function renderActions(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: Services['url-shortener-settings/presets']
      }
    }
  )
}
function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`service-template-item ${serviceNameKebabCase}-item`]: true,
        'hover-parent hover-parent--opacity': this.viewport.breakpoint.mdUp
      }
    },
    [
      renderInfo.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
